export default __webpack_public_path__ + "static/media/mh-logo-text-modern-health.7e1a0841.svg";